import React, { useMemo, useState } from 'react';
import { KeyMetricGraphBox } from 'src/components/organisms/KeyMetricGraphBox';
import { TimeseriesDataTableModal } from 'src/components/organisms/TimeseriesDataTableModal';
import { useChartEffectTickFormatter } from 'src/hooks/useEffectFormatter';
import { useKpiMetricLabels } from 'src/hooks/useKpiMetricLabels';
import { useMergeBenchmarkTimeseries } from 'src/hooks/useMergeBenchmarkTimeseries';
import { KeyMetricsDateFormatter } from 'src/utils/TickFormatters';
import { totalMetricDef } from 'src/utils/metricDefinitions';
import { useDADataContext } from '../../contexts/DADataContext';

export const TotalConversionsOTBox: React.FC = () => {
  const { sales, benchmarkSales } = useDADataContext();
  const { getMergedTimeSeries } = useMergeBenchmarkTimeseries();
  const { metricLabel } = useKpiMetricLabels();
  const valueTickFormatter = useChartEffectTickFormatter();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const title = `Total ${metricLabel}`;

  const data = useMemo(() => {
    return getMergedTimeSeries(
      sales.day,
      benchmarkSales.day,
      (v) => v,
      (v) => ({ benchmark: v.value }),
      false,
      'day',
    );
  }, [sales, benchmarkSales, getMergedTimeSeries]);

  return (
    <KeyMetricGraphBox
      title={title}
      legendLabel={metricLabel}
      data={data}
      xAxisFormatter={KeyMetricsDateFormatter}
      yAxisFormatter={valueTickFormatter}
      isError={sales.isError}
      isLoading={sales.isLoading}
      infoText={totalMetricDef(metricLabel)}
      exportEnabled
      onTableModalOpen={setModalIsOpen}
      tableModal={
        <TimeseriesDataTableModal
          isOpen={modalIsOpen}
          setIsOpen={setModalIsOpen}
          yFormatter={valueTickFormatter}
          dateFormatter={KeyMetricsDateFormatter}
          data={data}
          headerName={title}
        />
      }
    />
  );
};
